<template>
  <div>
    <div class="form_box">
      <div class="form_item">
          <img class="form_icon" src="../../assets/img/h5_login_mailbox.png" alt="">
          <input class="form_input" v-model="account" type="text" :placeholder="$t('m.input_email')">
      </div>
      <div class="form_item">
          <img class="form_icon" src="../../assets/img/h5_login_password.png" alt="">
          <input class="form_input" v-model="password" :type="isPassword?'password':'text'" :placeholder="$t('m.input_password')">
          <img class="sendcode_img" :src="isPassword?require('../../assets/img/h5_login_eye01.png'):require('../../assets/img/h5_login_eye02.png')" @click="isPassword = !isPassword">
      </div>
      <div class="fc-bind-btn" :class="{ active: formIsTrue }" @click="goLogin">{{$t('m.login')}}</div>
    </div>
    <div class="login_box" v-if="!isTgWebApp">

      <div class="login_other">

        <login-sdk-facebook styleType="circle" v-if="!isInRealLive"/>
        <login-sdk-google styleType="circle" v-if="!isInRealLive"/>
        <login-sdk-twitter v-if="thisLangcountry!=='zh' && !isInRealLive" />
        <!-- <login-sdk-apple /> -->
        <login-sdk-vk v-if="thisLangcountry=='ru' && !isInRealLive" />
        <login-sdk-instagram v-if="thisLangcountry!=='zh' && !isInRealLive" />
        <!-- <login-sdk-line v-if="thisLangcountry!=='zh'&&thisLangcountry!=='ru'" /> -->

        <div class="img_box" @click="phoneLogin">
          <img class="login_other_img" src="../../assets/img/h5_login_icon05.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var _self;
 import Vue from 'vue';
  import { Toast} from 'vant';
  Vue.use(Toast);
import { myMixin } from "@/tools/mixins.js";
import LoginSdkFacebook from './LoginSdk/LoginSdkFacebook';
import LoginSdkGoogle from './LoginSdk/LoginSdkGoogle';
import LoginSdkTwitter from './LoginSdk/LoginSdkTwitter';
import LoginSdkInstagram from './LoginSdk/LoginSdkInstagram';
import LoginSdkApple from './LoginSdk/LoginSdkApple';
import LoginSdkVK from './LoginSdk/LoginSdkVK';
import LoginSdkLine from './LoginSdk/LoginSdkLine';
import {isRealLive, isTelegramWebApp} from '../../util';
export default {
  name: "LoginPhone",
   mixins: [myMixin],
  components:{
    "login-sdk-facebook":LoginSdkFacebook,
    "login-sdk-google":LoginSdkGoogle,
    "login-sdk-twitter":LoginSdkTwitter,
    "login-sdk-instagram":LoginSdkInstagram,
    "login-sdk-apple":LoginSdkApple,
    "login-sdk-vk":LoginSdkVK,
    "login-sdk-line":LoginSdkLine,
  },
  props: {
    thisLangcountry:{
      type:String,
      default:function(){
        return "en"
      }
    }
  },
  data() {
    return {
      //thisLang:'en',
      isPassword:true, //是否显示密码
      formIsTrue:false, //表单是否输入完整
      account: "",
      password: "",
      countryArr:[],
      selCountry: {},
      isTgWebApp: false,
      isInRealLive: isRealLive(),
    };
  },
  computed: {
    bindmodel() {
        const { account, password } = this;
        return {
          account,
          password,
        };
      },
  },
   watch: {
      bindmodel: {
        handler: function ({account, password}) {
          //console.log(account);
          if(password.length<6||account.length<6 || account.indexOf('@')<0){
            this.formIsTrue = false;
          }else{
            this.formIsTrue = true;
          }
        },
      },
    },
  mounted() {
    _self = this;
    this.isTgWebApp = isTelegramWebApp(this.$route);

    //this.thisLang = this.getLang1(2);
  },
  methods: {
    isRealLive,
    goLogin(){
      if(!_self.formIsTrue)return false;
      this.confirmLogin(2,{
          "email": _self.account,
          "password":_self.password
        });

        localStorage.setItem('bcpayLoginEmail',_self.account);
    },
    phoneLogin(){
      this.$emit('isPhoneLogin', true)
    },

    emailLogin(){
      this.$emit('isEmailLogin', true)
    },

  },
};
</script>
<style scoped>
.btn_split {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.67rem;
  margin-bottom: 0.3rem;
}
.btn_split_line {
  width: 0.88rem;
  height: 1px;
  background-color: #F3F3F3;
}
.btn_split_txt {
  color: #999;
  font-size: 0.26rem;
  padding: 0 0.3rem;
}
.login_other {
  display: flex;
  justify-content: center;
  align-items: center;
}

.countryList .van-icon__image{
    float: left;
    margin-top: .2em;
}
.form_box{
  margin: .64rem;
}
  .form_item{
    display: flex;
    height: 1.14rem;
    align-items: center;
    border-bottom: 1px solid #F3F3F3;
  }
  .flag_icon{
    width: .28rem;
    height: .28rem;
  }
  .form_input{
    flex: 1;
    width: auto;
    height: .6rem;
    border: none;
    padding-left: .3rem;
  }
  .form_icon{
    width: .34rem;

  }
  .select_icon{
    width: .14rem;
    height: .14rem;
  }
input::-ms-input-placeholder {
  font-size: 0.32rem;
  color: #ddd;
}
input::-webkit-input-placeholder {
  font-size: 0.32rem;
  color: #ddd;
}
.sendcode_img{
  width: .42rem;
}
.sendcode_btn {
  padding: 0.1rem 0.3rem;
  height: 0.44rem;
  line-height: 0.44rem;
  background-color: #d8d8d8;
  color: #fff;
  border-radius: 1rem;
  text-align: center;
}
.sendcode_btn.active{
  background-color: #1fc3ff;
}
.countdown_btn{
  padding: 0.1rem .3rem;
  display: inline-block;
  font-size: 0.32rem;
  border: 1px solid #F3F3F3;
  color: #999;
  border-radius: 1rem;
  text-align: center;
}
.fc-bind-btn{
  padding: .2rem 0;
  display: block;
  margin: 2rem .8rem 0;
  font-size: .32rem;
  background-color: #d8d8d8;
  color: #fff;
  border-radius: 1rem;
  text-align: center;
}
.fc-bind-btn.active{
  background-color: #008aff;
}

.selcountry_title{
  height: .88rem;
  line-height: .88rem;
  text-align: center;
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 99;
  background-color: #fff;
  text-align: center;

}
.countryList{
  height: 100%;
  padding-top: .88rem;
  box-sizing: border-box;
  overflow: scroll;
}
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginEmail.vue